module.exports = __webpack_public_path__ + "img/close_transparent_white.636c2d26.svg";